<cb-dialog>
    <form class="flex-col flex"
          #designComplexityForm="ngForm">
        <cb-input type="text"
                  name="complexity"
                  label="Complexity"
                  [required]="true"
                  [(ngModel)]="mappedItem.complexity">
        </cb-input>
        <cb-input type="number"
                  name="targetWorkHours"
                  label="Target Work Hours"
                  [required]="true"
                  [(ngModel)]="mappedItem.targetWorkHours">
        </cb-input>
        <cb-input type="number"
                  name="targetCompletionHours"
                  label="Target Completion Hours"
                  [required]="true"
                  [(ngModel)]="mappedItem.targetCompletionHours">
        </cb-input>
        <cb-checkbox name="isActive"
                     label="Active"
                     [(ngModel)]="mappedItem.isActive">
        </cb-checkbox>
    </form>
    <div actions>
        <span class="flex"></span>
        <button mat-raised-button
                class="save-button"
                color="primary"
                (click)="save()"
                [disabled]="!designComplexityForm.dirty || !designComplexityForm.valid">
            Save
        </button>
        <button mat-raised-button
                (click)="cancel()">
            Cancel
        </button>
    </div>
</cb-dialog>
